var EmailFormDropDownView, EmailFormTextInputView, SupportUtilsHelper,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

EmailFormTextInputView = require('./text_input_view');

SupportUtilsHelper = require('../../../helpers/utils');

EmailFormDropDownView = (function(superClass) {
  extend(EmailFormDropDownView, superClass);

  function EmailFormDropDownView() {
    return EmailFormDropDownView.__super__.constructor.apply(this, arguments);
  }

  EmailFormDropDownView.prototype.tagName = 'li';

  EmailFormDropDownView.prototype.initialize = function() {
    EmailFormTextInputView.prototype.initialize.apply(this, arguments);
    this.elementID = "#languageDropdown";
    this.dropdownOptions = this.orderLanguagesForCountry(this.getCallBackLanguages());
    return this.template = {
      language_input_template: true,
      options: this.dropdownOptions
    };
  };

  EmailFormDropDownView.prototype.getCallBackLanguages = function() {
    return {
      US: {
        "language": [
          {
            locale_value: "en_US",
            text: I18n.translate('js.modules.support.english')
          }, {
            locale_value: "es_US",
            text: I18n.translate('js.modules.support.spanish')
          }
        ]
      }
    };
  };

  EmailFormDropDownView.prototype.orderLanguagesForCountry = function(languageDropDowns) {
    var languageList, ref;
    languageList = (ref = languageDropDowns[I18n.country]) != null ? ref.language : void 0;
    this.getDefaultCallBackLanguage(languageList);
    return languageList;
  };

  EmailFormDropDownView.prototype.getDefaultCallBackLanguage = function(languageList) {
    return _.each(languageList, function(object, key) {
      if (object['locale_value'] === I18n.locale) {
        return object['selected_state'] = "selected";
      }
    });
  };

  EmailFormDropDownView.prototype.getSelectedLocale = function() {
    return $("#languageDropdown option:selected").attr("value");
  };

  EmailFormDropDownView.prototype.populateInput = function(data) {
    if (this.isInputGiven()) {
      data.locale = this.getSelectedLocale();
      return EmailFormTextInputView.prototype.populateInput.apply(this, arguments);
    }
  };

  return EmailFormDropDownView;

})(EmailFormTextInputView);

module.exports = EmailFormDropDownView;

//# sourceMappingURL=data:application/json;base64,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
